var EmailFormDropDownView, EmailFormTextInputView, SupportUtilsHelper,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

EmailFormTextInputView = require('./text_input_view');

SupportUtilsHelper = require('../../../helpers/utils');

EmailFormDropDownView = (function(superClass) {
  extend(EmailFormDropDownView, superClass);

  function EmailFormDropDownView() {
    return EmailFormDropDownView.__super__.constructor.apply(this, arguments);
  }

  EmailFormDropDownView.prototype.tagName = 'li';

  EmailFormDropDownView.prototype.initialize = function() {
    EmailFormTextInputView.prototype.initialize.apply(this, arguments);
    this.elementID = "#languageDropdown";
    this.dropdownOptions = this.orderLanguagesForCountry(this.getCallBackLanguages());
    return this.template = {
      language_input_template: true,
      options: this.dropdownOptions
    };
  };

  EmailFormDropDownView.prototype.getCallBackLanguages = function() {
    return {
      US: {
        "language": [
          {
            locale_value: "en_US",
            text: I18n.translate('js.modules.support.english')
          }, {
            locale_value: "es_US",
            text: I18n.translate('js.modules.support.spanish')
          }
        ]
      }
    };
  };

  EmailFormDropDownView.prototype.orderLanguagesForCountry = function(languageDropDowns) {
    var languageList, ref;
    languageList = (ref = languageDropDowns[I18n.country]) != null ? ref.language : void 0;
    this.getDefaultCallBackLanguage(languageList);
    return languageList;
  };

  EmailFormDropDownView.prototype.getDefaultCallBackLanguage = function(languageList) {
    return _.each(languageList, function(object, key) {
      if (object['locale_value'] === I18n.locale) {
        return object['selected_state'] = "selected";
      }
    });
  };

  EmailFormDropDownView.prototype.getSelectedLocale = function() {
    return $("#languageDropdown option:selected").attr("value");
  };

  EmailFormDropDownView.prototype.populateInput = function(data) {
    if (this.isInputGiven()) {
      data.locale = this.getSelectedLocale();
      return EmailFormTextInputView.prototype.populateInput.apply(this, arguments);
    }
  };

  return EmailFormDropDownView;

})(EmailFormTextInputView);

module.exports = EmailFormDropDownView;

//# sourceMappingURL=data:application/json;base64,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
